<template>
  <div>
    <strong>Sync product</strong>
    <br/><br/>
    <div @keydown.enter="sync_product()">
      <label>Store: </label><StoreSelector v-model="selected_store" />
      <br/><br/>
      <label>Product Shopify ID:</label><input v-validate="'required|numeric'" type="text" v-model="product_shopify_id" name="Product Shopify ID">
      <p class="help is-danger" v-show="errors.has('Product Shopify ID')">
        {{ errors.first('Product Shopify ID') }}
      </p>
      <br/><br/><a id='submit' @click="sync_product()" class="button is-link" :disabled="buttonsDisabled"><span class="icon"><i class="fa fa-refresh"></i></span><span>Sync Product</span></a>
    </div>
  </div>
</template>

<script>
import auth from '../auth'
import StoreSelector from './StoreSelector'
import axios from 'axios'

export default {
  name: 'SyncProduct',
  computed: {
    formValidated () {
      return this.selected_store && Object.keys(this.fields).some(key => this.fields[key].validated) && Object.keys(this.fields).some(key => this.fields[key].valid)
    },
    buttonsDisabled () {
      return !this.formValidated || this.force_buttons_disabled
    }
  },
  data () {
    return {
      product_shopify_id: null,
      selected_store: null,
      force_buttons_disabled: false
    }
  },
  methods: {
    sync_product () {
      if (this.force_buttons_disabled) {
        return
      }

      if (this.formValidated) {
        this.force_buttons_disabled = true
        axios.post('/api/sync_product', {
          product_id: this.product_shopify_id,
          shop_url: this.selected_store
        })
          .then(response => {
            this.force_buttons_disabled = false
            this.$root.open_message_modal('Product Synced!')
          }).catch(response => {
            this.force_buttons_disabled = false
          })
      } else {
        this.$root.open_error_modal('Incomplete form!')
      }
    }
  },
  created () {
    auth.checkAuth(['write_products', 'read_products'])
  },
  components: {
    StoreSelector
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label { display: inline-block; width: 150px; text-align: left; }
</style>
